import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { shiftExtendedSchema } from '../types';

export const createStopShiftMutation = () =>
	createAuthMutation({
		params: declareParams<string>(),
		request: {
			method: 'DELETE',
			url: (id) => `/shift/${id}`,
			body: () => ({}),
		},
		response: {
			contract: zodContract(shiftExtendedSchema),
		},
	});
